import React from 'react';

import { Backdrop } from '@material-ui/core';

import { useBusyProgressState } from 'contexts/BusyProgressContext';
import { ReactComponent as SphereIcon } from 'assets/icons/assets/sphere-loader.svg';

import { LoaderWrapper } from './style';

export const SphereLoader = () => {
  const { isBusy } = useBusyProgressState();

  return (
    <Backdrop open={isBusy} style={{ zIndex: 9999 }}>
      <LoaderWrapper>
        <SphereIcon />
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="border" cx="50" cy="50" r="20" fill="none" strokeWidth="1" strokeMiterlimit="10"/>
          </svg>
        </div>
      </LoaderWrapper>
    </Backdrop>
  );
}
